/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, meta: NonNullable<unknown>, description: NonNullable<unknown> }} Intro_Pool_Option_AriaInputs */

const bn_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const de_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const el_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const en_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const es_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const fr_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const hi_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const hu_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const id_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const it_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const ja_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const ko_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const nl_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const pl_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const pt_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const ru_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const sv_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const tr_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const uk_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const vi_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const zh_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

const zh_hant_intro_pool_option_aria = /** @type {(inputs: Intro_Pool_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ${i?.description}`)
};

/**
* | output |
* | --- |
* | "{label} {meta} {description}" |
*
* @param {Intro_Pool_Option_AriaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_pool_option_aria = /** @type {((inputs: Intro_Pool_Option_AriaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Pool_Option_AriaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_pool_option_aria(inputs)
	if (locale === "de") return de_intro_pool_option_aria(inputs)
	if (locale === "el") return el_intro_pool_option_aria(inputs)
	if (locale === "en") return en_intro_pool_option_aria(inputs)
	if (locale === "es") return es_intro_pool_option_aria(inputs)
	if (locale === "fr") return fr_intro_pool_option_aria(inputs)
	if (locale === "hi") return hi_intro_pool_option_aria(inputs)
	if (locale === "hu") return hu_intro_pool_option_aria(inputs)
	if (locale === "id") return id_intro_pool_option_aria(inputs)
	if (locale === "it") return it_intro_pool_option_aria(inputs)
	if (locale === "ja") return ja_intro_pool_option_aria(inputs)
	if (locale === "ko") return ko_intro_pool_option_aria(inputs)
	if (locale === "nl") return nl_intro_pool_option_aria(inputs)
	if (locale === "pl") return pl_intro_pool_option_aria(inputs)
	if (locale === "pt") return pt_intro_pool_option_aria(inputs)
	if (locale === "ru") return ru_intro_pool_option_aria(inputs)
	if (locale === "sv") return sv_intro_pool_option_aria(inputs)
	if (locale === "tr") return tr_intro_pool_option_aria(inputs)
	if (locale === "uk") return uk_intro_pool_option_aria(inputs)
	if (locale === "vi") return vi_intro_pool_option_aria(inputs)
	if (locale === "zh") return zh_intro_pool_option_aria(inputs)
	return zh_hant_intro_pool_option_aria(inputs)
});